var map = {
	"./after-cleaning.jpg": 4228,
	"./balancing-kit.jpg": 3994,
	"./before-cleaning.jpg": 9235,
	"./deep-cleaning-detail.jpg": 2690,
	"./dial-indicator.jpg": 216,
	"./dirty-case.jpg": 8515,
	"./dirty-servo.jpg": 768,
	"./electric-meter.jpg": 7327,
	"./field-diagnosis-1.jpg": 8038,
	"./heavy-maintenance.jpg": 2127,
	"./laser-diagnosis.jpg": 8669,
	"./oil-mist-line.jpg": 2121,
	"./onsite-control.jpg": 1648,
	"./precision-parts.jpg": 485,
	"./rail-after.jpg": 8899,
	"./rail-before.jpg": 1384,
	"./relocation-lifting.jpg": 834,
	"./relocation-team.jpg": 2776,
	"./renishaw-kit.jpg": 1588,
	"./spindle-tension.jpg": 100,
	"./stability-system.jpg": 119,
	"./thermal-imaging.jpg": 2620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9048;